export const ID = Symbol();
export const SERVICE_TYPE_ID = Symbol();

export const indexedLocalesSymbol = Symbol();
export const localesModeSymbol = Symbol();
export const defaultLocaleSymbol = Symbol();
export const localeNoPathSymbol = Symbol();
